var map = {
	"./hangzhou-1.jpg": 4971,
	"./hangzhou-10.jpg": 18131,
	"./hangzhou-11.jpg": 31670,
	"./hangzhou-12.jpg": 18369,
	"./hangzhou-13.jpg": 40324,
	"./hangzhou-14.jpeg": 30120,
	"./hangzhou-15.jpeg": 60639,
	"./hangzhou-16.jpeg": 33346,
	"./hangzhou-17.jpeg": 55561,
	"./hangzhou-18.jpeg": 26388,
	"./hangzhou-19.jpeg": 72379,
	"./hangzhou-2.jpg": 12988,
	"./hangzhou-20.jpeg": 78859,
	"./hangzhou-21.jpeg": 60004,
	"./hangzhou-22.jpeg": 49861,
	"./hangzhou-23.jpeg": 48478,
	"./hangzhou-24.jpeg": 56583,
	"./hangzhou-25.jpeg": 12528,
	"./hangzhou-27.jpeg": 9674,
	"./hangzhou-28.jpeg": 39251,
	"./hangzhou-3.jpg": 34041,
	"./hangzhou-30.jpeg": 33882,
	"./hangzhou-31.jpeg": 43425,
	"./hangzhou-32.jpeg": 36320,
	"./hangzhou-33.jpeg": 77239,
	"./hangzhou-34.jpeg": 74830,
	"./hangzhou-35.jpeg": 89461,
	"./hangzhou-36.jpeg": 55540,
	"./hangzhou-37.jpeg": 18875,
	"./hangzhou-38.jpeg": 39202,
	"./hangzhou-39.jpeg": 59529,
	"./hangzhou-4.jpg": 63146,
	"./hangzhou-40.jpeg": 18497,
	"./hangzhou-41.jpeg": 51802,
	"./hangzhou-42.jpeg": 73143,
	"./hangzhou-43.jpeg": 27616,
	"./hangzhou-44.jpeg": 78421,
	"./hangzhou-45.jpeg": 58734,
	"./hangzhou-5.jpg": 18983,
	"./hangzhou-6.jpg": 65176,
	"./hangzhou-7.jpg": 73045,
	"./hangzhou-8.jpg": 6502,
	"./hangzhou-9.jpg": 49635,
	"./shanhaijing-202011.jpeg": 18969,
	"./suzhou-1.jpeg": 3560,
	"./suzhou-2.jpeg": 29001,
	"./suzhou-3.jpeg": 23138,
	"./suzhou-4.jpeg": 39491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87808;